import { render, staticRenderFns } from "./MenuCarousel.vue?vue&type=template&id=ef5c5f28"
import script from "./MenuCarousel.vue?vue&type=script&lang=js"
export * from "./MenuCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports